import React from 'react';
import { differenceInYears } from 'common-date/arithmetic';
import { isValid } from 'common-date/parse';
import { DateField, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import { useFormContext } from 'react-hook-form';

const DOBInput = () => {
  const { control } = useFormContext();
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ValidatedTextField
        defaultValue={null}
        name="dob"
        control={control}
        rules={{
          required: 'This field is required.',
          validate: (value) => {
            const validDate = isValid(value);
            if (!validDate) {
              return 'Enter a valid date.';
            }

            const validAge = differenceInYears(new Date(), value) >= 18;
            if (!validAge) {
              return 'You must be 18 or older to apply.';
            }

            return true;
          },
        }}
      >
        <DateField label="Date of Birth" />
      </ValidatedTextField>
    </LocalizationProvider>
  );
};

export default DOBInput;
